export var UNSUPPORTED_COUNTRY_KEYS = ['PSE', 'PRK', 'SYR', 'IRN', 'CUB'];
export var UNSUPPORTED_SUBDIVISIONS_BY_COUNTRIES = [
    {
        countryKey: 'USA',
        subdivisionKeys: ['AA', 'AE', 'AP'],
    },
];
export var COUNTRIES_WITH_UNSUPPORTED_SUBDIVISIONS = UNSUPPORTED_SUBDIVISIONS_BY_COUNTRIES.map(function (x) { return x.countryKey; });
export var PetriSpecs;
(function (PetriSpecs) {
    PetriSpecs["enableUnitedStatesMilitaryAddresses"] = "specs.stores.enableUnitedStatesMilitaryAddresses";
})(PetriSpecs || (PetriSpecs = {}));
//# sourceMappingURL=constants.js.map